import {
    apiRequest,
    configTunjanganDetail,
    configTunjanganUpdate
} from "../../../../../services/adapters/kepegawaian/configTunjanganService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", configTunjanganDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", configTunjanganUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository